import React from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import MoleculeAccountForm from "./MoleculeAccountForm";
import { palette } from "../../../../assets/styles/Palette";
// import images from "../../../../assets/styles/Images";

const MoleculeAccount = ({ onOpenPopup = () => {} }) => {
  // 성공 팝업 오픈은 폼 내부에서 직접 onOpenPopup을 호출하여 동작하도록 유지합니다.

  return (
    <AccountContainer>
      <h1>
        비밀번호 변경
      </h1>

      <MoleculeAccountForm onOpenPopup={onOpenPopup} /> {/* 팝업 열기 함수 전달 */}
    </AccountContainer>
  );
};

export default MoleculeAccount;


// CSS-in-JS 스타일링
const AccountContainer = styled.div`
  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 50px;

    p {
      font-size: 1rem;
      font-weight: 300;
      color: ${palette.gray};
    }
  }

  min-width: 400px;
  margin: 0 auto;
  background-color: #fff;
  text-align: center;
`;
